import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserPermissionService } from "../../user/user-permission/user-permission.service";
import { readOnly } from "../../user/user-permission/user-permission.data";
import { ErrorsService } from "common";

@Injectable({providedIn: 'root'})
export class TransactionSimulationGuard implements CanActivate {
  constructor(
    private readonly errorsService: ErrorsService,
    private readonly userPermissionService: UserPermissionService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.userPermissionService
      .granted([readOnly("servicing-simulating-transactions")])
      .pipe(
        map((result: boolean) => {
          if (!result) {
            this.errorsService.showForbiddenErrorPage();
          }
          
          return result;
        })
      );
  }
}